import React, { useEffect, useRef } from "react";
import BottonNavigation from "./bottonNavigation";
import { useRouter } from "next/router";
import { App, URLOpenListenerEvent } from "@capacitor/app";
import { hasOpenModals } from "@/components/ModalExtended";

function Layout({ children }: { children: React.ReactNode }) {
  const router = useRouter();
  const historyStack = useRef<string[]>([]);
  const backHandler = useRef<any | null>(null);
  const appUrlOpenHandler = useRef<any | null>(null);

  const handleRouteChange = (url: string) => {
    const last = historyStack.current[historyStack.current.length - 1];
    if (url !== last) {
      historyStack.current.push(url);
      console.log("Ruta añadida al stack:", url);
    }
  };
  useEffect(() => {
    // Siempre registra incluso la primera ruta cargada
    handleRouteChange(router.asPath);

    router.events.on("routeChangeComplete", handleRouteChange);

    // Manejo del botón 'back' de Android
    App.addListener("backButton", () => {
      // 👇 Si hay modales abiertos, NO hacemos nada aquí
      if (hasOpenModals()) return;

      if (historyStack.current.length > 1) {
        historyStack.current.pop();
        router.back();
      } else {
        if (confirm("¿Salir de la app?")) {
          App.exitApp();
        }
      }
    }).then((listener) => {
      backHandler.current = listener;
    });

    // Listener para deep links
    App.addListener("appUrlOpen", (event: URLOpenListenerEvent) => {
      console.log("Deep link recibido:", event.url);

      // Extraemos la ruta después del dominio
      // Ejemplo: https://beerswift.app/tabs/tab2 -> "/tabs/tab2"
      const slug = event.url.split(".app").pop();

      if (slug) {
        // Evitamos agregar rutas repetidas en el stack
        const last = historyStack.current[historyStack.current.length - 1];
        if (slug !== last) {
          historyStack.current.push(slug);
        }
        router.push(slug);
      }
    }).then((listener) => {
      appUrlOpenHandler.current = listener;
    });

    // Limpieza de listeners al desmontar
    return () => {
      router.events.off("routeChangeComplete", handleRouteChange);
      if (backHandler.current) {
        backHandler.current.remove();
      }
      if (appUrlOpenHandler.current) {
        appUrlOpenHandler.current.remove();
      }
    };
  }, [router]);

  return (
    <div className=" mx-auto">
      <div className="min-h-screen">{children}</div>
      <Footer />
      <BottonNavigation />
    </div>
  );
}

export default Layout;

export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-100 text-black/90 pt-4 px-4 pb-8">
      <div className="container mx-auto">
        <div className="grid md:grid-cols-4 gap-8 mb-3">
          {/* Logo y descripción */}
          <div className="space-y-6">
            <div className="flex items-center space-x-3">
              <img
                src="/icons/logo152.webp"
                className="rounded-xl w-10 h-10"
                alt=""
              />
              <div>
                <h1 className="font-bold text-xl">Supermercados D`ley</h1>
                <p className="text-xs text-gray-400">
                  Corporación Semaj Cia LTDA
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Footer inferior */}
        <div className="border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-xs">
              © {currentYear} Corporación Semaj. Todos los derechos reservados.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
